import * as workerTimers from 'worker-timers'
import { JS_ENV } from 'consts'
// This file allows us to mock the worker-timers library in our tests
export default {
  setInterval: JS_ENV === 'test' ? setInterval : workerTimers.setInterval,
  clearInterval: JS_ENV === 'test' ? clearInterval : workerTimers.clearInterval,
  setTimeout: JS_ENV === 'test' ? setTimeout : workerTimers.setTimeout,
  clearTimeout: JS_ENV === 'test' ? clearTimeout : workerTimers.clearTimeout,
}
